// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ConfiguracoesSistema_GetByNameResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/configuracoes_sistema/get_by_name/{nome}.
 *
 * dados is a single config_sistema row (Configuracoes_sistema_model::get_by_name
 * — `SELECT * FROM config_sistema WHERE nome = ...`), or null when not found.
 * The row carries the config_sistema columns
 * { config_sistema_id, nome, titulo, descricao, categoria, valor_padrao }
 * (see ConfiguracoesSistema_ListRow for the per-row shape). The model returns
 * a raw stdClass from `->row()`, so the value is passed through as-is to
 * preserve the legacy wire shape (object-or-null with success:true).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ConfiguracoesSistema_GetByNameResponseDados = object;

export type ConfiguracoesSistema_GetByNameResponse = ApiResponse<ConfiguracoesSistema_GetByNameResponseDados>;

registerResponseContract('ConfiguracoesSistema_GetByNameResponse', {})
